// Checkout can be pointed at a local stand-in via EXPO_PUBLIC_CHECKOUT_BASE_URL
// to test before the dashboard API endpoint is deployed. Defaults to the real
// API, so production is unaffected.
const API_BASE_URL =
  process.env.EXPO_PUBLIC_CHECKOUT_BASE_URL ??
  process.env.EXPO_PUBLIC_API_BASE_URL;

/**
 * Asks the dashboard API to create a PaymentIntent for a testing kit and
 * returns its client secret. Shared by the native (Payment Sheet) and web
 * (Stripe Elements) checkout paths. No Stripe import here, so it is safe on
 * both platforms. Price and patient identity are decided server-side.
 */
export async function fetchTestingCheckoutSecret(args: {
  token: string | undefined;
  tenantId: string;
  productId: string;
}): Promise<string | null> {
  // New-style route: mounted at /api (no tenant prefix), not /api/:tenant.
  const res = await fetch(`${API_BASE_URL}/orders/checkout`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(args.token ? { Authorization: `Bearer ${args.token}` } : {}),
    },
    body: JSON.stringify({ productId: args.productId }),
  });
  if (!res.ok) return null;
  const body = (await res.json()) as {
    data?: { paymentIntentClientSecret?: string };
  };
  return body.data?.paymentIntentClientSecret ?? null;
}
